/**
 * @generated SignedSource<<0bb28cbbf61a4c84282ae92f6727af98>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GSNForContentSidebarEntryPoint$data = {
  readonly assetsVertical_checkPermissions?: {
    readonly __typename: "AssetsVerticalCheckPermissionsSuccess";
    readonly results: ReadonlyArray<{
      readonly permissionId: string;
      readonly permitted: boolean;
      readonly resourceId: string;
    }>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly assetsVertical_tenantContext?: {
    readonly __typename: "AssetsVerticalTenantContextSuccess";
    readonly tenantContext: {
      readonly assetsVerticalWorkspaceAri: string | null;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly navPlatL1MenuData: {
    readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
  } | null;
  readonly navPlatSidebarData: {
    readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Apps" | "Nav4Filters" | "Nav4Operations" | "Nav4Plans" | "Nav4Projects" | "Nav4Roadmaps_query" | "useGlobalShortcutsDataRelay" | "useNetworkSideNavUserData" | "useShowRoadmapsUpsell">;
  readonly " $fragmentType": "GSNForContentSidebarEntryPoint";
};
export type GSNForContentSidebarEntryPoint$key = {
  readonly " $data"?: GSNForContentSidebarEntryPoint$data;
  readonly " $fragmentSpreads": FragmentRefs<"GSNForContentSidebarEntryPoint">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v1 = [
  {
    "kind": "FragmentSpread",
    "name": "useNavSettingsService"
  }
],
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "currentURL"
    },
    {
      "kind": "RootArgument",
      "name": "fetchGlobalShortcutsAvailableProducts"
    },
    {
      "kind": "RootArgument",
      "name": "isItamEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "isRoadmapUpsellEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "itamStaticChecks"
    },
    {
      "kind": "RootArgument",
      "name": "navPlatMenuDataEntityAri"
    },
    {
      "kind": "RootArgument",
      "name": "navPlatSidebarDataEntityAri"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    }
  ],
  "kind": "Fragment",
  "name": "GSNForContentSidebarEntryPoint",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "useNetworkSideNavUserData"
    },
    {
      "condition": "isRoadmapUpsellEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useShowRoadmapsUpsell"
        }
      ]
    },
    {
      "condition": "fetchGlobalShortcutsAvailableProducts",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useGlobalShortcutsDataRelay"
        }
      ]
    },
    {
      "alias": "navPlatL1MenuData",
      "args": [
        {
          "kind": "Variable",
          "name": "entityAri",
          "variableName": "navPlatMenuDataEntityAri"
        },
        (v0/*: any*/)
      ],
      "concreteType": "SettingsNavigationCustomisation",
      "kind": "LinkedField",
      "name": "settings_navigationCustomisation",
      "plural": false,
      "selections": (v1/*: any*/)
    },
    {
      "alias": "navPlatSidebarData",
      "args": [
        {
          "kind": "Variable",
          "name": "entityAri",
          "variableName": "navPlatSidebarDataEntityAri"
        },
        (v0/*: any*/)
      ],
      "concreteType": "SettingsNavigationCustomisation",
      "kind": "LinkedField",
      "name": "settings_navigationCustomisation",
      "plural": false,
      "selections": (v1/*: any*/)
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Apps"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Filters"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Operations"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Plans"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "currentURL",
          "variableName": "currentURL"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Nav4Projects"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Roadmaps_query"
    },
    {
      "condition": "isItamEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            (v2/*: any*/)
          ],
          "kind": "LinkedField",
          "name": "assetsVertical_tenantContext",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "AssetsVerticalTenantContext",
                  "kind": "LinkedField",
                  "name": "tenantContext",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "assetsVerticalWorkspaceAri"
                    }
                  ]
                }
              ],
              "type": "AssetsVerticalTenantContextSuccess"
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "checks",
              "variableName": "itamStaticChecks"
            },
            (v2/*: any*/)
          ],
          "kind": "LinkedField",
          "name": "assetsVertical_checkPermissions",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "AssetsVerticalPermissionCheckResult",
                  "kind": "LinkedField",
                  "name": "results",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "resourceId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "permissionId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "permitted"
                    }
                  ]
                }
              ],
              "type": "AssetsVerticalCheckPermissionsSuccess"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "b9fd25f48c6f2bbbd310900a6f346c63";

export default node;
